<template>
    <!-- 手机 -->
  <div class="home" ref="home">
    <div class="header">
      <div class="header__title">
        <i class="iconfont icon-diqiu header__title__img"></i>
        <div>
            <div>华深海外仓</div>
            <div>WALSON WAREHOUSE</div>
        </div>
      </div>
      <div class="header__tab">
        <div @click="tabChange(item.value)" class="header__tab__item" :class="{'actived':item.value==activedValue}" v-for="(item) in tabs" :key="item.value">
          {{ item.label }}
        </div>
      </div>
    </div>
    <div class="topImg">
      <img src="@/assets/home/topImg3-1.png" alt="">
      <div class="topImg__info">
        <div class="topImg__info__top">全球智能仓储物流解决方案</div>
        <div class="topImg__info__bottom">专注B2B跨境供应链，赋能企业高效出海</div>
      </div>
    </div>
    <div class="inner">
      <!-- 服务介绍 -->
      <div class="service" ref="service">
        <div class="service__head">我们的服务优势</div>
        <div class="service__content">
          <div class="service__item" v-for="item in serviceList" :key="item.id">
            <i  :class="`iconfont service__item__icon ${item.icon}`"></i>
            <div class="service__item__title">{{ item.title }}</div>
            <div class="service__item__info">{{ item.info }}</div>
            <div class="service__item__info" style="margin-top: 0;">{{ item.info1 }}</div>
          </div>
        </div>
        
      </div>
      <!-- 关于我们 -->
      <div class="aboutUs" ref="aboutUs">
        <div class="aboutUs__img">
          <img src="@/assets/home/img3.png" alt="" >
        </div>
        <div class="aboutUs__right">
          <div class="aboutUs__right__title">关于华深海外仓</div>
          <div class="aboutUs__right__info">
            <div>华深海外仓是一家专注于跨境电商物流服务的综合型物流企业。</div>
            <div>我们提供双模式物流接入可供灵活选择：</div>
            <div>商家自主发货至海外仓，或使用「华深海外仓」端到端物流（空运/海运头程+清关+入仓）。</div>
            <br>
            <div>依托先进的仓储管理系统和专业的运营团队，我们为跨境电商卖家提供一站式物流解决方案，包括仓储、一件代发、换标贴标、退换货等全方位服务。</div>
          </div>
          <div class="aboutUs__right__bottom">
            <div class="aboutUs__right__bottom__item">
              <div class="aboutUs__right__bottom__item__num">99.8%</div>
              <div class="aboutUs__right__bottom__item__info">订单精准率</div>
            </div>
            <div class="aboutUs__right__bottom__item">
              <div class="aboutUs__right__bottom__item__num">2-5日达</div>
              <div class="aboutUs__right__bottom__item__info">美国全境</div>
            </div>
            <div class="aboutUs__right__bottom__item">
              <div class="aboutUs__right__bottom__item__num">24h</div>
              <div class="aboutUs__right__bottom__item__info">极速出货</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 联系我们 -->
      <div class="contact" ref="contact">
        <div class="contact__title">联系我们</div>
        <div class="contact__content">
            <div class="contact__way">
                <div class="contact__way__info" v-for="item in contactList" :key="item.id">
                <div><i  :class="`iconfont contact__way__info__icon ${item.icon}`"></i></div>
                <div>
                    <div class="contact__way__info__title">
                    {{ item.title }}:<span class="contact__way__info__detail">{{ item.info }}</span>
                    </div>
                    <!-- <div ></div> -->
                </div>
            </div>
            </div>
            <div class="contact__right">
                <img src="@/assets/home/address1.png" alt="">
            </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer__content">
        <div class="footer__item">
          <div class="footer__item__title">华深海外仓</div>
          <div class="footer__item__title">WALSON WAREHOUSE</div>
          <div class="footer__item__info">专业的跨境电商物流服务商</div>
        </div>
        <!-- <div class="footer__item">
          <div class="footer__item__title">快速连接</div>
          <div class="footer__item__info click" @click="tabChange('home')">首页</div>
          <div class="footer__item__info click" @click="tabChange('service')">服务介绍</div>
          <div class="footer__item__info click" @click="tabChange('aboutUs')">关于我们</div>
          <div class="footer__item__info click" @click="tabChange('contact')">联系我们</div>
        </div> -->
        <div class="footer__item">
          <div class="footer__item__title">联系方式</div>
          <div class="footer__item__info">电话：13609196587</div>
          <div class="footer__item__info">邮箱：contact@walsongo.com</div>
        </div>
<!--        <div class="footer__item">-->
<!--          <div class="footer__item__title">关于我们</div>-->
<!--          <div class="footer__item__img">-->
<!--            <i  :class="`iconfont footer__item__icon  icon-weixin`"></i>-->
<!--            <i  :class="`iconfont footer__item__icon  icon-weibo`"></i>-->
<!--            <i  :class="`iconfont footer__item__icon  icon-in`"></i>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="footer__copyright">
        © 深圳市森华腾网络科技有限公司 版权所有	粤ICP备2025430014号 粤公网安备44030002007327号
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobilePage',
  data() {
    return {
      tabs:[
        {
          label:'首页',
          value:'home'
        },
        {
          label:'服务介绍',
          value:'service'
        },
        {
          label:'关于我们',
          value:'aboutUs'
        },
        {
          label:'联系我们',
          value:'contact'
        },
      ],
      serviceList:[
        {
          id:10000001,
          icon:"icon-cangku",
          title:'美国本土化仓库',
          info:"自营标准化仓库覆盖美国东西海岸核心枢纽，支持一件代发、退货处理，大货中转。"
        },
        {
          id:10000002,
          icon:"icon-yunshuwuliudingdan",
          title:'高效配送',
          info:"自动抓取平台订单，智能匹配最优物流渠道，支持拆包、贴标、定制包装等增值服务"
        },
        {
          id:10000003,
          icon:"icon-keshihua-",
          title:'实时监控',
          info:"专业的仓储管理系统，实时掌握库存和物流状态",
          info1:""
        },
      ],
      contactList:[
         {
          id:20000001,
          icon:"icon-dingwei",
          title:'公司地址',
          info:"深圳市龙华区钓鱼台路聚厂A栋411"
        },
        {
          id:20000002,
          icon:"icon-dianhua",
          title:'联系电话',
          info:"13609196587"
        },
        {
          id:20000003,
          icon:"icon-dianziyouxiang",
          title:'电子邮箱',
          info:"contact@walsongo.com"
        },
      ],
      activedValue:'home'
    }
  },
  components: {
  },
  created() {
   console.log(window.innerWidth)
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {
    // 切换页面位置
    tabChange(value){
      this.activedValue = value
      const element = this.$refs[ this.activedValue];
      if (element) {
        const top = element.offsetTop - 100;
        window.scrollTo({
          top,
          behavior: 'smooth'
        });
      }
    }
  },
  computed: {},
}
</script>

<style scoped lang="less">
.home {
  // margin-top: -0.92rem;
  background-color: #F9FAFB;
}
.header{
  padding: 0 0.7rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 2rem;
  background-color: #fff;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 99;
  &__title{
    font-weight: bold;
    display: flex;
    align-items: center;
    &__img{
      margin-right: 0.1rem;
      color: #1296db;
      font-size: 1rem;
    }
    >div{
     >div{
        font-size: 0.5rem;
        color: #1F2937;
     }
    }
  }
  &__tab{
    display: flex;
    justify-content: space-between;
    align-items: center;
    &__item{
      font-size: 0.4rem;
      margin-left: 0.5rem;
      color: #4B5563;
      cursor: pointer;
    }
  }
}
.topImg{
  position: relative;
  >img{
    //height: 13rem;
    width: 100%;
  }
  &__info{
    position: absolute;
    color: #fff;
    left: 1rem;
    top: 2.9rem;
    &__top{
      font-size: 1rem;
      font-weight: bold;
      margin-bottom: 0.3rem;
    }
    &__bottom{
      font-size: 0.6rem;
    }
  }
}
.actived{
    color: #2563EB ;
}
.inner {
  margin: 0 auto;
  box-sizing: border-box;
  // padding: 0.74rem 1.1rem 1.03rem;
  // padding: 0 1rem;
  padding-top: 1rem;
  .service{
    text-align: center;
    padding: 0 1rem;
    margin-bottom: 1.5rem;
    &__head{
      font-size: 0.7rem;
      text-align: center;
      font-weight: bold;
      margin-bottom: 0.5rem;
    }
    &__content{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    &__item{
      height: 5.6rem;
      width: 14rem;
      background-color: #fff;
      padding: 0.7rem;
      padding-bottom: 0.4rem;
      box-shadow: 0px 0.1rem 0.15rem -0.03rem rgba(0,0,0,0.1), 0px 0.04rem 0.06rem -0.04rem rgba(0,0,0,0.1);
      border-radius: 0.08rem;
      padding-top: 0.9rem;
      margin-top: 0.8rem;
      &__title{
        font-size: 0.6rem;
        font-weight: bold;
        margin-top: 0.2rem
      }
      &__info{
        font-size: 0.55rem;
        color: #4B5563;
        margin-top: 0.5rem;
        line-height: 0.9rem;
      }
      &__icon{
        font-size: 1.8rem;
        color: #2563EB;
      }
    }
  }
  .aboutUs{
     padding: 0 1.5rem;
     padding-top: 1.5rem;
     padding-bottom: 1.5rem;
     background-color: #EFEFEF;
    //  display: flex;
    //  justify-content:center;
    //  align-items: center;
     margin-bottom: 1.2rem;
     &__img{
      width: 100%;
      //height: 5.2rem;
      margin-right: 1rem;
     }
     &__right{
        margin-top: 0.5rem;
      &__title{
        font-size: 0.6rem;
        font-weight: bold;
        margin-bottom: 0.4rem;
      }
      &__info{
        >div{
          font-size: 0.5rem;
          color: #4B5563;
          line-height: 0.83rem;
        }
      }
      &__bottom{
        // padding-left: 0.4rem;
        // padding-right: 0.4rem;
        margin-top: 0.4rem;
        display: flex;
        justify-content: space-between;
        &__item{
          text-align: center;
          &__num{
            font-size: 0.6rem;
            font-weight: bold;
            color: #2563EB ;
            margin-bottom: 0.05rem;
          }
          &__info{
            font-size: 0.5rem;
            color: #4B5563 ;
          }
        }
      }
     }
  }
  .contact{
    padding: 0 1.5rem;
    &__title{
        font-size: 0.7rem;
        font-weight: bold;
        text-align: center;
        margin-bottom: 1rem;
      }
    &__content{
    //   display: flex;
    //   justify-content: space-around;
    //   align-items: center;
    }
    &__way{
        &__info{
          display: flex;
          align-items: center;
          margin-bottom: 0.5rem;
          margin-top: 0.5rem;
          &__icon{
            color: #2563EB;
            margin-right: 0.2rem;
            font-size: 0.8rem;
          }
          &__title{
            font-size: 0.5rem;
            font-weight: bold;
            margin-bottom: 0.05rem;
          }
          &__detail{
            font-size: 0.45rem;
            font-weight: 400;
            margin-left: 0.3rem;
            line-height: 0.7rem;
          }
        }
    }
    &__right{
    //   width: 9rem;
    //   margin-left: 1rem;
      >img{
        width: 100%;
      }
    }
  }
}
.footer{
    background-color: #181e2f;
    margin-top: 1.5rem;
    color: #fff;
    padding-top: 0.5rem;
    // padding-left: 2rem;
    // padding-right: 2rem;
    &__content{
      display: flex;
      justify-content: space-around;
      padding-bottom: 0.5rem;
      padding-left: 1rem;
      padding-right: 1rem;
    }
    &__item{
      // margin-left: 1rem;
      // margin-right: 2rem;
      &__title{
        font-size: 0.45rem;
        font-weight: bold;
        margin-bottom: 0.2rem;
      }
      &__info{
        color: #9CA3AF;
        font-size: 0.4rem;
        margin-bottom: 0.08rem;
      }
      &__icon{
        color: #9CA3AF;
        margin-right: 0.25rem;
      }
    }
    .click{
      cursor: pointer;
    }
    &__copyright{
      margin-left: 0.5rem;
      margin-right: 0.5rem;
      border-top: 1px #9CA3AF solid;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      text-align: center;
      font-size: 0.4rem;
      color: #9CA3AF;
    }
  }
</style>
